module.exports = __webpack_public_path__ + "static/media/CentroMedicoSantaIsabel.801ac1ec.svg";